module.exports = __webpack_public_path__ + "img/home_marker.2a92d016.svg";